import { Link } from "react-router-dom";
import OfficialLINE from "@/components/ui/OfficialLINE";
import ExternalLink from "@/components/ui/ExternalLink";
import InfoPageLayout from "@/components/templates/infoPage/InfoPageLayout";
import InfoPageSection from "@/components/templates/infoPage/InfoPageSection";
import {
  InfoPageList as Ul,
  InfoPageListItem as Li,
} from "@/components/templates/infoPage/InfoPageList";
import { OFFICIAL_EMAIL, OFFICIAL_LINE } from "@/constants/common";

const ShoppingInfoPage = () => {
  return (
    <InfoPageLayout
      pageTitle="線上購物說明"
      bannerImage={{
        default: "/images/banner-shopping-info.jpg",
        desktop: "/images/banner-shopping-info.jpg",
      }}
      breadcrumbs={[{ label: "首頁", path: "/" }, { label: "線上購物說明" }]}
      ogImage="/images/banner-shopping-info-og.jpg"
      bannerImagAlign="right"
    >
      <p>親愛的顧客您好！在訂購前，請先閱讀以下細節，以確保您的權益。</p>

      {/* 店家備貨流程 */}
      <InfoPageSection title="店家備貨流程">
        <Ul>
          <Li>咖啡豆採「新鮮烘焙」，每週五晚上 12:00 結單統計，於週六 / 週日進行烘焙。</Li>
          <Li>烘焙完成後，將於週一 ~ 週三安排出貨，約 2～3 個工作天可寄達。</Li>
          <Li>標註「現貨」的商品，為近期烘焙好的咖啡，下單後 2 天內寄出。</Li>
        </Ul>
      </InfoPageSection>

      {/* 訂購須知 */}
      <InfoPageSection title="訂購須知">
        <Ul>
          <Li>無需註冊會員即可購買。</Li>
          <Li>
            若選擇「銀行轉帳」付款，請於轉帳後，加入
            <OfficialLINE />
            ，主動聯繫告知轉帳後 5 碼，經店家確認收到款項後，將安排咖啡豆烘焙與出貨。
          </Li>
        </Ul>
      </InfoPageSection>

      {/* 訂購通知 */}
      <InfoPageSection title="訂購通知">
        <Ul>
          <Li>
            下單後，會寄送訂單內容至您填寫的 Email，您訂購的商品與填寫的資訊可於 Email 內確認。
          </Li>
          <Li>
            如未收到信件，請確認垃圾信件匣，或向
            <OfficialLINE />
            聯繫協助查詢。
          </Li>
          <Li>確認訂單後店家會更新訂單狀態。</Li>
          <Li>下單後，如有變更需求，請於 LINE 儘速聯繫，我們將視訂單進度協助。</Li>
        </Ul>
      </InfoPageSection>

      {/* 付款選項 */}
      <InfoPageSection title="付款選項" id="payment-methods">
        <Ul>
          <Li>信用卡（Visa / Master / JCB）</Li>
          <Li>超商取貨付款</Li>
          <Li>銀行轉帳</Li>
        </Ul>
      </InfoPageSection>

      {/* 寄送選項 */}
      <InfoPageSection title="寄送選項" id="shipping-methods">
        <Ul>
          <Li>超商取貨：7-11、全家、萊爾富（送達需 2–3 日）</Li>
          <Li>郵局宅配（送達需 2–3 日）</Li>
        </Ul>
        <p>
          目前僅寄送台灣本島，如有寄送外島需求請
          <OfficialLINE />
          詢問。
        </p>
      </InfoPageSection>

      {/* 運費 */}
      <InfoPageSection title="運費" id="shipping-fee">
        <p>購物商品滿 800 元可享免運優惠，未達金額則需酌收運費（活動期間另有滿額免運優惠）。</p>
        <Ul>
          <Li>7-11 超商：65 元</Li>
          <Li>全家 超商：65 元</Li>
          <Li>萊爾富 超商：55 元</Li>
          <Li>郵寄：80 元</Li>
        </Ul>
        <p>如選擇超商取貨，無故未取，運費將由顧客自行吸收。</p>
        <p>若遇極端氣候或物流量暴增影響配送時程，到貨日將可能延後，敬請見諒</p>
      </InfoPageSection>

      {/* 商品包裝與保存建議 */}
      <InfoPageSection title="商品包裝與保存建議" id="product-packaging">
        <Ul>
          <Li>
            咖啡豆商品皆以原豆包裝，若需要代研磨成咖啡粉，請於下單時於備註欄註明您沖煮咖啡的使用器具。
          </Li>
          <Li>
            本店皆使用含有單向氣閥的豆袋包裝咖啡豆，以確保商品的新鮮。咖啡豆為農產品，建議保存於乾燥陰涼處，開封後儘早飲用，最佳賞味期限
            2 個月內。
          </Li>
          <Li>
            網站上的商品屬於常態性的商品，部分商品因數量有限，有可能無法及時上下架。若在訂購時想確認是否還有庫存，可於
            <OfficialLINE />
            詢問。
          </Li>
        </Ul>
      </InfoPageSection>

      <InfoPageSection title="退換貨說明">
        相關規範請參考
        <Link to="/return-policy" className="brand-link-with-underline">
          退換貨說明頁面
        </Link>
        ，下單前請先閱讀以保障您的權益。
      </InfoPageSection>

      {/* 聯絡方式 */}
      <InfoPageSection title="聯絡方式" id="contact">
        <p>有任何問題歡迎使用以下方式與我們聯繫</p>
        <Ul>
          <Li>
            LINE 官方帳號：
            <ExternalLink href={OFFICIAL_LINE.LINK}>{OFFICIAL_LINE.AT_ID}</ExternalLink>
          </Li>
          <Li>E-mail：{OFFICIAL_EMAIL}</Li>
        </Ul>
      </InfoPageSection>
    </InfoPageLayout>
  );
};

export default ShoppingInfoPage;
